import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import '@solana/wallet-adapter-react-ui/styles.css';

import { Toaster } from 'sonner';
import { VaultStateProvider } from './context/VaultContext';
import { DemoWalletProvider } from './context/DemoWalletContext';
import Landing from './pages/Landing';

export default function App() {
  const endpoint = useMemo(() => clusterApiUrl('devnet'), []);
  const wallets = useMemo(
    () => [new PhantomWalletAdapter(), new SolflareWalletAdapter()],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <DemoWalletProvider>
            <VaultStateProvider>
              <div className="noise min-h-screen text-white font-body">
                <Landing />
                <Toaster
                  position="top-right"
                  theme="dark"
                  toastOptions={{
                    style: {
                      background: 'rgba(12, 52, 44, 0.92)',
                      border: '1px solid rgba(227, 239, 38, 0.35)',
                      color: '#E2FBCE',
                      backdropFilter: 'blur(20px)',
                      fontFamily: 'Manrope, sans-serif',
                    },
                  }}
                />
              </div>
            </VaultStateProvider>
          </DemoWalletProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
